import React from 'react';
import {
  shape,
  string,
  arrayOf,
  number
} from 'prop-types';
import { useImpression } from '@thd-olt-component-react/impression';
import {
  Card,
  CardMedia,
  Typography,
  CardContent,
  CardBody,
} from '@one-thd/sui-atomic-components';
import { useSpecialBuy } from '../../context/SpecialBuyProvider';

const MobileCategoryTab = ({ category, entryId, index }) => {
  const { specialBuyEndpoint } = useSpecialBuy();
  const { categoryId, name, image, itemIds } = category;

  const { ref, clickID } = useImpression({
    data: {
      id: entryId,
      name: 'SpecialBuyBanner',
      component: 'SpecialBuyBanner',
      position: index,
      type: 'product',
      category: categoryId
    },
  });

  return (
    <Card
      disablePadding
      disableGutters
      href={`${specialBuyEndpoint}#${categoryId}`}
      CardActionAreaProps={{ target: '_blank' }}
      ref={ref}
      // eslint-disable-next-line react/no-unknown-property
      clickid={clickID}
      className="sui-border-none"
    >
      <CardContent disablePadding>
        <CardMedia
          src={image.url}
          alt={`${name} product image`}
          aspect="square"
          width="fit"
          loading="lazy"
        />
      </CardContent>
      <CardContent disablePadding="x">
        <CardBody lineClamp>
          <Typography align="center">
            {name}
          </Typography>
          <Typography align="center">
            ({itemIds.length})
          </Typography>
        </CardBody>
      </CardContent>
    </Card>
  );
};

MobileCategoryTab.propTypes = {
  category: shape({
    name: string.isRequired,
    itemIds: arrayOf(string.isRequired).isRequired,
    categoryId: string.isRequired,
    image: shape({
      url: string.isRequired
    }).isRequired
  }).isRequired,
  entryId: string,
  index: number.isRequired,
};

MobileCategoryTab.defaultProps = {
  entryId: '',
};

export { MobileCategoryTab };
